import { render, staticRenderFns } from "./memory.vue?vue&type=template&id=0081bbb3&scoped=true&"
import script from "./memory.vue?vue&type=script&lang=js&"
export * from "./memory.vue?vue&type=script&lang=js&"
import style0 from "./memory.vue?vue&type=style&index=0&id=0081bbb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0081bbb3",
  null
  
)

export default component.exports